import { render, staticRenderFns } from "./EntryOnBid.vue?vue&type=template&id=64a1f8e4&"
import script from "./EntryOnBid.vue?vue&type=script&lang=js&"
export * from "./EntryOnBid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports